import { Component, OnInit, ViewChild } from '@angular/core';
import { confirm, alert } from 'devextreme/ui/dialog';
import { DxDataGridComponent } from '../../../../node_modules/devextreme-angular';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Location } from '@angular/common';
import * as _ from 'lodash';
import validationEngine from 'devextreme/ui/validation_engine';
import { SharedModule } from 'src/app/shared/shared.module';
import { AppInformationService, AuthenticationService, RAFUnitOfWork } from 'src/app/core/core.module';

@Component({
    selector: 'app-invoice-create',
    templateUrl: './invoice-create.component.html',
    styleUrls: ['./invoice-create.component.scss'],
    standalone: false
})
export class InvoiceCreateComponent implements OnInit {
    key: any;
    employee: any;
    companies: any;
    scheduleGroups: any;
    states: any;
    countries: any[] = ['US', 'OTHER'];
    timeCategories: any;
    currentCategoryIds: any;
    selectedCategoryIds: any;
    validationGroup = 'mainValidationGroup';
    errorAction = 'saving';

    shipAddressSelectedRowKeys: any[] = [];
    readOnly = true;

    onToolbarPreparing = SharedModule.onToolbarPreparing;
    @ViewChild('shippingAddressGrid')
    shippingAddressGrid: DxDataGridComponent;

    constructor(
        private uow: RAFUnitOfWork,
        public auth: AuthenticationService,
        private route: ActivatedRoute,
        protected location: Location,
        private modalService: BsModalService,
        private appInfo: AppInformationService,
        private router: Router
    ) {}

    async ngOnInit() {
        this.appInfo.pleaseWaitShow();
        this.readOnly = !this.auth.hasRole('Admin');
        // this.states = this.uow.lookups.states;

        this.key = this.route.snapshot.params['id'];
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async getData() {
        if (this.key === 'new') {
            this.employee = this.uow.employees.createEntity();
        } else {
            this.employee = await this.uow.employees.byId(this.key);
            console.log(this.employee);
        }
    }

    hasChanges() {
        return this.uow.hasChanges();
    }

    async delete() {
        if (!this.employee) return;
        const result = await confirm('Are you sure you want to delete this employee?', `${this.appInfo.settings.company}`);
        if (!result) return;
        this.employee.deleted = new Date();
        await this.uow.commit();
        this.close();
    }

    async save() {
        if (!this.validate()) {
            return;
        }
        this.appInfo.pleaseWaitShow();

        await this.uow.commit();
        if (this.key === 'new') {
            this.router.navigate(['../' + this.employee.id], { relativeTo: this.route, replaceUrl: true, state: { navigateOnSaveNew: true } });
        }
        this.key = this.employee.id;
        this.appInfo.pleaseWaitHide();
    }

    cancel() {
        this.uow.rollback();
        this.close();
    }

    close() {
        try {
            this.location.back();
        } catch {
            this.router.navigate(['../'], { relativeTo: this.route });
        }
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig(this.validationGroup);
        if (groupConfig) {
            const result = validationEngine.validateGroup(this.validationGroup);
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before ${this.errorAction}.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
